import React, { useEffect, useState, useRef, useContext } from 'react';
import { Button, Select, Table, DatePicker, Form, Row, Col, Input } from 'antd';
import http from '../Http';
import utils from '../utils';
import config from '../Config';
import { CloudDownloadOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

const GuiDing_Alarms = {
    1: "High Voltage Switch Alarm", 
    2: "Low Voltage Switch Alarm", 
    3: "Smoke Sensor Alarm", 
    5: "Electric Heating Protection", 
    6: "Indoor High Temperature Alarm", 
    7: "Indoor Low Temperature Alarm", 
    8: "Indoor High Humidity Alarm", 
    9: "Indoor Low Humidity Alarm", 
    10: "Condensation Temperature Too High", 
    11: "Evaporation Temperature Too Low", 
    12: "Indoor Temperature Sensor Fault", 
    13: "Indoor Humidity Sensor Fault", 
    14: "Condensation Temperature Fault", 
    15: "Evaporation Temperature Fault", 
    18: "Forced Cooling Room Temperature Too Low", 
    19: "Forced Heating Room Temperature Too High", 
    23: "Supply Air Temperature Fault", 
    24: "Ambient Temperature Fault", 
    26: "Condensation Temperature Warning", 
    27: "Evaporation Temperature Warning", 
    28: "Water Leakage Alarm", 
    29: "Compressor Current Too High", 
    30: "Electric Heating Current Too High", 
}

const GuiDing_Switchs = {
    31: "Supply Fan", 
    32: "Compressor", 
    33: "Electric Heating", 
    34: "Outdoor Fan", 
    35: "Fault Output", 
}

const GuiDing_Analog = {
    1: "Indoor Humidity", 
    2: "Indoor Temperature", 
    3: "Condensation/Liquid Supply Temperature", 
    4: "Evaporation/Supply Air Temperature", 
    5: "Supply Air/Outdoor Temperature", 
}

function getTableScroll() {
    var th = document.getElementsByClassName("ant-table-thead")[0];
    let tHeaderBottom = 0
    if (th) {
        tHeaderBottom = th.getBoundingClientRect().top
    }
    let height = `calc(100vh - ${tHeaderBottom + 100}px)`
    return height
}

function AirConditionerDataExporter(props) {
    const { t } = useTranslation();
    const setTip = useContext(utils.tipContext)

    const [pageNo, setPageNo] = useState(0)
    const [pageSize, setPageSize] = useState(100)
    const [rows, setRows] = useState([])
    const [rowTotal, setRowTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [deviceSelectOptions, setDeviceSelectOptions] = useState([]);


    const [deviceAddressOptions, setDeviceAddressOptions] = useState([])
    const [deviceAddress, setDeviceAddress] = useState('')
    const [STime, setSTime] = useState(moment());
    const [ETime, setETime] = useState(moment().add(1, "days"));
    const [SN, setSN] = useState("")
    const [next, setNext] = useState(0)
    const [dates, setDates] = useState(null)
    const [range, setRange] = useState(null)

    const [airType, setAirType] = useState(1); // 1 TingXiang, 2 GuiDing
    const [columns, setColumns] = useState([])
    const [columnsStr, setColumnsStr] = useState([])

    const refTimerDeviceSearcher = useRef(null);
    const refDeviceSearchValue = useRef(null);
    const refDownloader = useRef(null)

    const [scrollY, setScrollY] = useState("")

    const [form] = Form.useForm();

    const dateTimeFormat = new Intl.DateTimeFormat();
    const timeZone = dateTimeFormat.resolvedOptions().timeZone;
    const timeZoneOffset = -new Date().getTimezoneOffset()*60;

    const columnsForTingXiang = [
        {
            title: "",
            width: 40,
            fixed: 'left',
            render: (v, r, idx) => {
                return (pageNo * pageSize + idx + 1);
            }
        }, {
            title: t('Upload Time')+"("+timeZone+")",
            dataIndex: 'CreateTime',
            width: 200,
        }, {
            title: t('Device Type'),
            dataIndex: 'DeviceType',
            width: 90,
            render: (v) => {
                return v 
            }
        }, {
            title: t('Device Address'),
            dataIndex: 'DeviceAddress',
            width: 120,
        }, {
            title: t('Evaporator Sensor Fault'),
            dataIndex: 'EvaporatorSensorFault',
            width: 168,
            transform: {
                map:{
                    0: t('Normal'),
                    1: t('Fault'),
                }
            }
        }, {
            title: t('Cabinet TempAndHum Sensor Fault'),
            dataIndex: 'CabTempHumSensorFault',
            width: 240,
            transform: {
                map:{
                    0: t('Normal'),
                    1: t('Fault'),
                }
            }
        }, {
            title: t('Cabinet HighHum Alarm'),
            dataIndex: 'CabinetHighHumAlarm',
            width: 170,
            transform: {
                map:{
                    0: t('Normal'),
                    1: t('Alarm'),
                }
            }
        }, {
            title: t('Cabinet HighTemp Alarm'),
            dataIndex: 'CabinetHighTempAlarm',
            width: 175,
            transform: {
                map:{
                    0: t('Normal'),
                    1: t('Alarm'),
                }
            }
        }, {
            title: t('Cabinet LowTemp Alarm'),
            dataIndex: 'CabinetLowTempAlarm',
            width: 170,
            transform: {
                map:{
                    0: t('Normal'),
                    1: t('Alarm'),
                }
            }
        }, {
            title: t('High Pressure Alarm'),
            dataIndex: 'HighPressureAlarm',
            width: 150,
            transform: {
                map:{
                    0: t('Normal'),
                    1: t('Alarm'),
                }
            }
        }, {
            title: t('LackOrLeakage Fluorine'),
            dataIndex: 'LackOrLeakageFluorine',
            width: 170,
            transform: {
                map:{
                    0: t('Normal'),
                    1: t('Alarm'),
                }
            }
        }, {
            title: t('Compressor Relay'),
            dataIndex: 'CompressorRelay',
            width: 130,
            transform: {
                map:{
                    0: t('Off'),
                    1: t('On'),
                }
            }
        }, {
            title: t('Heating Relay'),
            dataIndex: 'HeatingRelay',
            width: 110,
            transform: {
                map:{
                    0: t('Off'),
                    1: t('On'),
                }
            }
        }, {
            title: t('Fan Relay'),
            dataIndex: 'FanRelay',
            width: 100,
            transform: {
                map:{
                    0: t('Off'),
                    1: t('On'),
                }
            }
        }, {
            title: t('Ventilation Relay'),
            dataIndex: 'VentilationRelay',
            width: 140,
            transform: {
                map:{
                    0: t('Off'),
                    1: t('On'),
                }
            }
        }, {
            title: t('System On/Off'),
            dataIndex: 'SystemOnOff',
            width: 140,
            transform: {
                map:{
                    0: t('Off'),
                    1: t('On'),
                }
            }
        }, {
            title: t('Cabinet Temperature'),
            dataIndex: 'CabinetTemperature',
            width: 150,
            render: v => {
                return v ? v / 10 : v
            },
            transform: {
                signed: 0x7ffff,
                multiplicative_inverse: 10
            }
        }, {
            title: t('Cabinet Humidity'),
            dataIndex: 'CabinetHumidity',
            width: 150,
            render: v => {
                return v ? v / 10 : v
            },
            transform: {
                signed: 0x7fff,
                multiplicative_inverse: 10
            }
        }
    ];
    

    useEffect(() => {
        setScrollY(getTableScroll());
        setAirType(1);
    }, [])

    useEffect(() => {
        if (airType == 1) {
            setColumns(columnsForTingXiang);
            let strColumns = [];
            for (let i = 0; i < columnsForTingXiang.length; i++) {
                const c = columnsForTingXiang[i];
                if (c.dataIndex) {
                    strColumns.push({
                        title: c.title,
                        dataIndex: c.dataIndex,
                        transform: c.transform,
                        width: c.width,
                    });
                }
            }
            strColumns = encodeURIComponent(JSON.stringify(strColumns));
            setColumnsStr(strColumns);
        } else if (airType == 2) {
            const cs = [...columnsForTingXiang.slice(0,4)];
            for (const k in GuiDing_Alarms) {
                cs.push({
                    title: t(GuiDing_Alarms[k]),
                    dataIndex: k.toString(),
                    width: 120,
                    render: v => {
                        return v == 1 ? t('Alarm') : t('Normal')
                    },
                    transform: {
                        map:{
                            0: t('Normal'),
                            1: t('Alarm'),
                        }
                    }
                })
            }
            for (const k in GuiDing_Switchs) {
                cs.push({
                    title: t(GuiDing_Switchs[k]),
                    dataIndex: k.toString(),
                    width: 120,
                    render: v => {
                        return v == 1 ? t('On') : t('Off')
                    },
                    transform: {
                        map:{
                            0: t('Off'),
                            1: t('On'),
                        }
                    }
                })
            }
            for (const k in GuiDing_Analog) {
                cs.push({
                    title: t(GuiDing_Analog[k]),
                    dataIndex: (parseInt(k)+1000).toString(),
                    width: 120,
                    transform: {
                        signed: 0x7ffff,
                        multiplicative_inverse: 10  
                    }
                })
            }
            
            setColumns(cs);
            let strColumns = [];
            for (let i = 0; i < cs.length; i++) {
                const c = cs[i];
                if (c.dataIndex) {
                    strColumns.push({
                        title: c.title,
                        dataIndex: c.dataIndex,
                        transform: c.transform,
                        width: c.width,
                    });
                }
            }
            strColumns = encodeURIComponent(JSON.stringify(strColumns));
            setColumnsStr(strColumns);
        }
    }, [airType, t]);

    const handleSearchDevice = (v) => {
        if (refTimerDeviceSearcher.current != null) {
            clearTimeout(refTimerDeviceSearcher.current);
        }
        refDeviceSearchValue.current = v;

        const id = form.getFieldValue("DeviceID");

        refTimerDeviceSearcher.current = setTimeout(async () => {
            const resp = await http.post("device/id-name/list", {
                DistributorIsTheSameAsTheDeviceID: id || "",
                SN: v,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[AirConditionerDataExporter]", e);
                return null;
            });

            if (refDeviceSearchValue.current !== v) {
                return;
            }

            try {
                if (resp.code !== 200) {
                    setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load_device_list_error") });
                    return;
                }

                const ls = resp.data.map(({ SN, ID }) => {
                    return (
                        <Select.Option key={SN} value={SN}>{SN}</Select.Option>
                    );
                });
                setDeviceSelectOptions(ls);
            } catch (e) {
                console.log("[AirConditionerDataExporter]", e);

                setTip({ open: true, severity: "error", msg: t("load_device_list_error") });
            }
        }, 300);
    }

    //取历史数据
    useEffect(() => {
        if (!SN) return;

        let active = true;

        (async () => {
            setLoading(true);

            let resp = await http.post("air-conditioner/history/list", {
                PageNo: pageNo,
                PageSize: pageSize,
                SerialNumber: SN,
                DeviceAddress: deviceAddress,
                STime: STime.format('YYYY-MM-DD'),
                ETime: ETime.format('YYYY-MM-DD'),
                TimezoneOffset: timeZoneOffset,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                return null;
            });

            if (!active) {
                return;
            }

            if (resp === null || resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load data error") });
                setRowTotal(0)
                setRows([])
                return;
            }

            //console.log('air: ', resp.data);

            //2025.3.26
            let aType = 1;
            if (resp.data.Rows.length > 0) {
                aType = resp.data.Rows[0].DeviceType == 1 ? 1 : 2;
                setAirType(aType);
            }

            if (aType == 1) {
                resp.data.Rows = resp.data.Rows.map(item => {
                    //handle data
                    let coilData = item.CoilData;
                    let registerData = item.RegisterData;
                    if(coilData && coilData.length >= 4) {
                        //'800a' => 128 10 => '0000000101010000'
                        const v1 = parseInt('0x'+coilData.slice(0, 2)).toString(2).padStart(8, '0').split('').reverse().join('');
                        const v2 = parseInt('0x'+coilData.slice(2, 4)).toString(2).padStart(8, '0').split('').reverse().join('');
                        const vs = v1 + v2;

                        //对vs的每个bit进行处理
                        const EvaporatorSensorFault = vs[0] == 0 ? t('Normal') : t('Fault')
                        const CabTempHumSensorFault = vs[1] == 0 ? t('Normal') : t('Fault')
                        const CabinetHighHumAlarm = vs[2] == 0 ? t('Normal') : t('Alarm')
                        const CabinetHighTempAlarm = vs[3] == 0 ? t('Normal') : t('Alarm')
                        const CabinetLowTempAlarm = vs[4] == 0 ? t('Normal') : t('Alarm')
                        const HighPressureAlarm = vs[5] == 0 ? t('Normal') : t('Alarm')
                        const LackOrLeakageFluorine = vs[6] == 0 ? t('Normal') : t('Alarm')
                        const CompressorRelay = vs[7] == 0 ? t('Off') : t('On')
                        const HeatingRelay = vs[8] == 0 ? t('Off') : t('On')
                        const FanRelay = vs[9] == 0 ? t('Off') : t('On')
                        const VentilationRelay = vs[10] == 0 ? t('Off') : t('On')
                        const SystemOnOff = vs[11] == 0 ? t('Off') : t('On')

                        item = {
                            ...item,
                            EvaporatorSensorFault,
                            CabTempHumSensorFault,
                            CabinetHighHumAlarm,
                            CabinetHighTempAlarm,
                            CabinetLowTempAlarm,
                            HighPressureAlarm,
                            LackOrLeakageFluorine,
                            CompressorRelay,
                            HeatingRelay,
                            FanRelay,
                            VentilationRelay,   
                            SystemOnOff,
                        }
                    }
                    if(registerData) {  //只取前2个字
                        if(registerData.length < 8) { //小于8个字符则补足8个
                            registerData = registerData.padEnd(8, '0');
                        } else if(registerData.length > 8) {  //大于8个字符则取前8个
                            registerData = registerData.slice(0, 8);
                        }
                        //将hex字符串转换为bit串
                        const bits = registerData.split('').map(v => Number('0x' + v).toString(2).padStart(4, '0')).join('')  
                        //将bit的串按双字节分割为数组
                        const bytes = bits.match(/(.{16})/g);
                        //对bytes的每个字进行处理
                        const vs = bytes.map(v => {
                            v = parseInt(v, 2)
                            if(v > 0x7fff) {
                                v -= 0xffff + 1
                            }
                        })
                        const CabinetTemperature = vs[0];
                        const CabinetHumidity = vs[1];

                        item = {
                            ...item,
                            CabinetTemperature,
                            CabinetHumidity,
                        }
                    }

                    return item;
                })
            } else if (aType == 2) {
                resp.data.Rows = resp.data.Rows.map((r) => {
                    const item = {...r };
                    item.CoilData = item.CoilData.match(/.{1,2}/g).map(v => parseInt(v, 16));
                    item.RegisterData = item.RegisterData.match(/.{1,2}/g).map(v => parseInt(v, 16));
                    for (const k in GuiDing_Alarms) {
                        const bk = Math.floor(parseInt(k)/ 8);
                        const bitk = parseInt(k) % 8;
                        const v = (item.CoilData[bk] >> bitk)&1;
                        item[k.toString()] = v;
                    }
                    for (const k in GuiDing_Switchs) {
                        const bk = Math.floor(parseInt(k)/ 8);
                        const bitk = parseInt(k) % 8;
                        const v = (item.CoilData[bk] >> bitk)&1;
                        item[k.toString()] = v;
                    }
                    for (const k in GuiDing_Analog) {
                        const i = parseInt(k) - 1;
                        let v = (parseInt(item.RegisterData[2*i]) << 8) + parseInt(item.RegisterData[2*i+1]);
                        if (v > 0x7fff) {
                            v -= 0xffff + 1;
                        }
                        item[(parseInt(k) + 1000).toString()] = (v/10).toFixed(1);
                    }
                    
                    return item;
                });
            }

            setRowTotal(resp.data.RowTotal);
            setRows(resp.data.Rows);
            setLoading(false);
        })();

        return () => {
            active = false;
        };
    }, [pageNo, pageSize, SN, deviceAddress, STime, ETime, next]);

    //取DeviceAddress列表
    useEffect(() => {
        if (!SN) return;

        let active = true;

        (async () => {
            let resp = await http.post("air-conditioner/device-address/list", {
                SerialNumber: SN,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                return null;
            });

            if (!active) {
                return;
            }

            if (resp === null || resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load data error") });
                setDeviceAddressOptions([])
                return;
            }

            //所有设备地址项
            var ts = [];
            ts.push(<Select.Option key='' value=''>{t('All')}</Select.Option>)
            for (let k in resp.data) {
                const v = resp.data[k].DeviceAddress
                ts.push(<Select.Option key={v} value={v}>{v}</Select.Option>)
            } 

            setDeviceAddressOptions(ts);
        })();

        return () => {
            active = false;
        };
    }, [SN]);

    const handleExport = () => {
        if (!refDownloader.current) {
            return;
        }
        refDownloader.current.click()
    }



    return (
        <div style={{
            // width: "100%", 
            // height: "100%",
            flex: "1 1 auto",
            display: "flex",
            flexDirection: "column",
            backgroundColor: '#EFF8FE',
            padding: 8,
            overflow: "hidden",
        }}>
            <div style={{
                flex: "0 0 auto",
                // width: "1000px",
            }}>
                <Form
                    form={form}
                    initialValues={{
                        DateRange: [moment(), moment()]
                    }}
                    style={{
                        padding: 24,
                        background: '#fbfbfb',
                        border: '1px solid #d9d9d9',
                        borderRadius: 2
                    }}
                >
                    <Row gutter={24}>
                        <Col span={7} key="DeviceID">
                            <Input.Group compact>
                                <Button>{t("Device SN")}</Button>
                                <Form.Item
                                    name="DeviceID"
                                    label=""
                                    style={{display: 'inline-block', width: 'calc(100% - 120px)'}}
                                >
                                    <Select
                                        showSearch
                                        placeholder={t("Device SN")}
                                        defaultActiveFirstOption={false}
                                        showArrow={false}
                                        filterOption={false}
                                        onSearch={(value) => {
                                            setDeviceAddressOptions([])
                                            setDeviceAddress('')
                                            handleSearchDevice(value);
                                        }}
                                        onSelect={(value, option) => setSN(value)}
                                    >{deviceSelectOptions}</Select>
                                </Form.Item>
                            </Input.Group>
                        </Col>
                        <Col span={6} key="DeviceAddress">
                            <Input.Group compact>
                                <Button>{t("Device Address")}</Button>
                                <Form.Item
                                    name="DeviceAddress"
                                    label=""
                                    style={{display: 'inline-block', width: 'calc(100% - 120px)'}}
                                >
                                    <Select
                                        showSearch
                                        placeholder={t("Device Address")}
                                        defaultActiveFirstOption={true}
                                        showArrow={false}
                                        filterOption={false}
                                        onSelect={(value) => {
                                            setDeviceAddress(value)
                                            setPageNo(0)
                                        }}
                                        value={deviceAddress} 
                                    >{deviceAddressOptions}</Select>
                                </Form.Item>
                            </Input.Group>
                        </Col>
                        <Col span={6} key="DateRange" >
                            <Form.Item
                                name="DateRange"
                                label=""
                            >
                                <DatePicker.RangePicker
                                    style={{ borderRadius: '20px'}}
                                    value={[STime, ETime]}
                                    disabledDate={(current) => {
                                        if(!dates) {
                                            return false;
                                        }
                                        if(range == 'start') {
                                            return current.diff(dates[0], 'days') > 7
                                        } else if(range == 'end') {
                                            return Math.abs(current.diff(dates[1], 'days')) > 7
                                        }
                                    }}
                                    onCalendarChange={(dates, dateStrings, info) => {
                                        setRange(info.range)
                                        setDates(dates)
                                    }}
                                    onOpenChange={(open) => {
                                        if(!open) {
                                            if (dates && dates.length > 1) {
                                                setSTime(dates[0])
                                                setETime(dates[1])
                                            }
                                            setRange(null)
                                            setDates(null)
                                        }
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={5} style={{ textAlign: 'right' }}>
                            <Button type="primary" shape="round" onClick={() => {setPageNo(0); setNext(next + 1)}}>
                                {t("Search")}
                            </Button>
                            <Button
                                shape="round"
                                style={{ margin: '0 8px' }}
                                onClick={() => {
                                    form.resetFields();
                                }}
                            >
                                {t("Clear")}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div style={{
                flex: '0 0 auto',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
                paddingTop: 8,
                paddingBottom: 8,
            }}>
                <Button disabled={rows.length < 1 ? true : false} onClick={handleExport} type="primary" icon={<CloudDownloadOutlined />} size="middle" />
            </div>
            <div style={{
                flex: "1 1 1px",
                position: "relative",
            }}>
                <div style={{ position: "absolute", height: '100%', width: "100%", overflow: "hidden" }}>
                    <Table
                        columns={columns}
                        pagination={{
                            pageSizeOptions: [25, 50, 100],
                            current: pageNo + 1,
                            pageSize: pageSize,
                            total: rowTotal,
                            showSizeChanger: true,
                            showTotal: (total) => { return t('Total {{total}}', { total }) },
                            onShowSizeChange: (current, size) => {
                                setPageSize(size);
                            },
                            onChange: (page, pageSize) => {
                                setPageNo(page - 1);
                            }
                        }}
                        tableLayout="fixed"
                        bordered={true}
                        size="small"
                        loading={loading}
                        rowKey="ID"
                        dataSource={rows}
                        scroll={{ x: 'max-content', y: scrollY }}
                    >
                    </Table>
                </div>
            </div>

            <a ref={refDownloader} style={{ display: "none" }} href={config.apiUrl + "data-export/air-conditioner/history/do?Token=" + http.token + "&SerialNumber=" + SN + "&DeviceAddress=" + deviceAddress + "&AirType=" + airType + "&STime=" + STime.format("YYYY-MM-DD") + "&ETime=" + ETime.format("YYYY-MM-DD") + "&TimezoneOffset=" + timeZoneOffset + "&Columns=" + columnsStr}></a>
        </div>
        
    )
}

export default AirConditionerDataExporter;